import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'pcafp';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        operador: '3'
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)} className='uplay-form'>
          <input
            className='color-input'
            disabled={onLogin}
            required={true}
            placeholder={translate('PlaceholderUserName')}
            tabIndex={1}
            type="text"
            autoCorrect="off"
            autoCapitalize="none"
            id="username"
            onChange={e => setUsername(e.target.value)}
            name="username"
          />
          <input
            className='color-input'
            required={true}
            disabled={onLogin}
            placeholder={translate('Contraseña')}
            tabIndex={1}
            type="password"
            autoCorrect="off"
            autoCapitalize="none"
            name="password"
            onChange={e => setPassword(e.target.value)}
          />
          <div className="buttons">
            {!onLogin ?
              <button
                block={!parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                name="submit"
                disabled={!props.turnstileSuccess}
              >
                {translate('Ingresar')}
              </button> :
              <Progress animated color="primary" value={100} className='uplay-progress' />}
          </div>
          <div className='uplay-error-container'>
            <strong className='uplay-error-msg'>{error.message} </strong>
          </div>
          <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
